/** item types constant file for react drag and drop (react-dnd) */

const ItemTypes = {
  FILE_CARD: 'FILE_CARD', // contains {fileId: string}
  FOLDER_CARD: 'FOLDER_CARD', // contains {folderId: string}
};

export default ItemTypes;
